import { useThemeColors } from 'hooks'

const nivoThemeColorDefinitions = {
	axis: { variable: '--chart-axis', fallback: '#535255' },
	grid: { variable: '--chart-grid', fallback: '#DDD' },
	// The axis TICK MARKS. They are rules, not text, so they do not take the
	// label ink. nivo hardcodes them to #777777 when the theme omits them, and
	// those were live on the dark dashboard. `--chart-axis-line` holds that
	// exact #777777 in light.
	//
	// The axis DOMAIN line is NOT in here on purpose. nivo defaults it to
	// `transparent`, not to #777777, so no chart in this app has ever drawn a
	// baseline. If this theme sets `axis.domain`, all 15 charts that spread it
	// gain a solid rule in LIGHT that was never there. Leave the key out and
	// nivo keeps its transparent default in both themes. A chart that really
	// wants a baseline must set `axis.domain` itself, the way
	// add-account-chart.tsx and campaign-chart.tsx do.
	axisLine: { variable: '--chart-axis-line', fallback: '#777777' },
	crosshair: { variable: '--chart-crosshair', fallback: '#000000' }
} as const

/**
 * Shared nivo theme. Every nivo chart must pass `theme={useNivoTheme()}` —
 * without it, axis tick text falls back to nivo's hardcoded #333, grid lines
 * to #ddd and the crosshair to #000, all invisible-wrong in dark mode. Charts
 * that need extra theme keys can spread this and extend it.
 */
export const useNivoTheme = () => {
	const colors = useThemeColors(nivoThemeColorDefinitions)
	return {
		axis: {
			ticks: { line: { stroke: colors.axisLine }, text: { fill: colors.axis } },
			legend: { text: { fill: colors.axis } }
		},
		grid: { line: { stroke: colors.grid } },
		// nivo merges this over its defaults, so the 0.75 opacity and the 6 6
		// dash pattern stay. Only the stroke moves to a token.
		crosshair: { line: { stroke: colors.crosshair } },
		legends: { text: { fill: colors.axis } },
		labels: { text: { fill: colors.axis } },
		// Tooltips are frozen light islands in both themes (see the :root /
		// [data-theme='light'] binding in App.css). nivo's default BasicTooltip
		// takes its colors from here, not from a DOM subtree, so it gets the
		// same white body and light-mode ink explicitly.
		tooltip: { container: { background: '#fff', color: '#535255' } }
	}
}
